import PageData from './PageData';
import ImageGallery from './components/ImageGallery';
import LocationMap from './components/LocationMap';
import ProjectUnitsTabs from './ProjectUnitsTabs';
import {Brand} from './types/Brand';
import {Device} from './types/Device';
import Brochures from './project/Brochures';
import ProperatiLamudiProjectPageStickyButtons from "./properatilamudi/ProperatiLamudiProjectPageStickyButtons";
import ProperatiLamudiProjectContactModal from "./properatilamudi/project-page/ProperatiLamudiProjectContactModal";
import {connect} from "./connect";
import ChatOptions from "./components/ChatOptions";

const viewMore = document.getElementById('view-more-description')!;
const description = document.getElementById('description-text')!;
const facilitiesList = document.getElementById('facilities__options')!;
const viewMoreFacilitiesTrigger = document.getElementById('facilities__view-more');
const viewLessFacilitiesTrigger = document.getElementById('facilities__view-less');
const returnToContentTrigger = document.getElementById('come_back')!;

(window as any).initAdForm = (pageData: PageData) => {
  let brand = pageData.brand;
  if (isLamudiMyPropertyBrand(brand) || brand === Brand.PROPERATI) {
    // @ts-ignore
    window.ga = function(){};
    connect();
  }
  ImageGallery.init(pageData, '.gallery-swiper-container', brand === Brand.PROPERATI || isLamudiMyPropertyBrand(brand));
  LocationMap.init(pageData);
  new ProjectUnitsTabs(pageData).setupEventListeners();
  if (isLamudiMyPropertyBrand(brand) || (pageData.device == Device.MOBILE && brand === Brand.PROPERATI)) {
    ProperatiLamudiProjectPageStickyButtons.init(pageData);
    ProperatiLamudiProjectContactModal.init(pageData);
  }
  new Brochures().setupEventListeners();
  if (pageData.device == Device.MOBILE && brand != Brand.NUROA) {
    stickyMenu();
  }
  ChatOptions.init(pageData);

  document.getElementById('header-to-map')?.addEventListener('click', scrollToMap);
  if (viewMore) viewMore.addEventListener('click', expandDescriptionNewDesign);
  if (viewMoreFacilitiesTrigger) viewMoreFacilitiesTrigger.addEventListener('click', expandFacilities);
  if (viewLessFacilitiesTrigger) viewLessFacilitiesTrigger.addEventListener('click', shortenFacilities);
  if (returnToContentTrigger) returnToContentTrigger.addEventListener('click', returnToContent);
};

function isLamudiMyPropertyBrand(brand: string) {
  return brand === Brand.LAMUDI || brand === Brand.MYPROPERTY
}

const returnToContent = () => {
  history.back();
};

const stickyMenu = () => {
  const observerSwiper = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        mantainHeader();
      } else {
        changeHeader();
      }
    });
  }, {});
  observerSwiper.observe(document.getElementById('transparent-div')!);
};

const changeHeader = () => {
  document.getElementById('navigation-mobile')?.classList.add('fixed-menu');
};

const mantainHeader = () => {
  document.getElementById('navigation-mobile')?.classList.remove('fixed-menu');
};

const scrollToMap = () => {
  document.getElementById('location-map-wrapper')!.scrollIntoView({ behavior: 'smooth' });
};

const expandDescriptionNewDesign = () => {
  viewMore.classList.add('hidden');
  description.innerText = description.dataset.expandeddescription!;
};

const expandFacilities = () => {
  facilitiesList.classList.add('expanded');
  facilitiesList.classList.add('all-visible');
  viewMoreFacilitiesTrigger!.classList.add('hidden');
  if (viewLessFacilitiesTrigger) viewLessFacilitiesTrigger!.classList.remove('hidden');
};

const shortenFacilities = () => {
  facilitiesList.classList.remove('expanded');
  facilitiesList.classList.remove('all-visible');
  viewMoreFacilitiesTrigger!.classList.remove('hidden');
  viewLessFacilitiesTrigger!.classList.add('hidden');
};


